module.exports = "<span>\r\n    <select>\r\n    </select>\r\n </span>\r\n";